import { render, staticRenderFns } from "./LanguageMain.vue?vue&type=template&id=3405424f&scoped=true"
import script from "./LanguageMain.vue?vue&type=script&lang=js"
export * from "./LanguageMain.vue?vue&type=script&lang=js"
import style0 from "./LanguageMain.vue?vue&type=style&index=0&id=3405424f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405424f",
  null
  
)

export default component.exports